import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './UpdateToAllOutletsModal.css';

const UpdateToAllOutletsModal = props => {
  const { onConfirm, onCancel, show, itemName } = props;
  const contentsUpdateToAllOutlet = [
    '<b>Attributes</b> inside this product will be updated to all outlets (except stock & SKU).',
    `<b>Pricing</b> will be updated only if we find the matching variant & sales type combination, we will not add/delete any combination. <a href="https://mokaposhelp.zendesk.com/hc/id/articles/900000454066-Cara-Membuat-Sales-Type-How-to-Create-Sales-Type" target="_blank"> Learn about pricing. </a>`,
    `<b>Sales type & modifier </b> will only be activated if it's available in the sales type & modifier library.`,
  ];
  return (
    <Modal className={styles['modal-container']} show={show}>
      <Modal.Header>
        <Modal.Title className={styles['modal-title']}>
          Update to All Outlets?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <span className={styles['text-color']}>
            Product with the name <b>"{itemName}"</b> will be updated to all
            outlets.
          </span>
          <div className={styles['content-container']}>
            <ul>
              {contentsUpdateToAllOutlet.map(content => (
                <li
                  className={styles['list-content']}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              ))}
            </ul>
          </div>
          <div className={styles['content-footer']}>
            <span className={styles['content-footer-text']}>
              Learn more about how this feature works&nbsp;
            </span>
            <a href="https://mokaposhelp.zendesk.com/hc/id" target="_blank">
              here.
            </a>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <span className="pull-right">
          <button className="btn btn-default" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={onConfirm}>
            Confirm
          </button>
        </span>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateToAllOutletsModal;
